import { render, staticRenderFns } from "./CodewordSets.vue?vue&type=template&id=04310cb4&scoped=true&"
import script from "./CodewordSets.vue?vue&type=script&lang=js&"
export * from "./CodewordSets.vue?vue&type=script&lang=js&"
import style0 from "./CodewordSets.vue?vue&type=style&index=0&id=04310cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04310cb4",
  null
  
)

export default component.exports